import { Controller } from "@hotwired/stimulus"

// Simple search controller without lodash dependency
export default class extends Controller {
  static targets = ["input", "results"]
  
  connect() {
    this.timeout = null
  }

  search(event) {
    // Clear previous timeout
    if (this.timeout) {
      clearTimeout(this.timeout)
    }
    
    // Simple debouncing without lodash
    this.timeout = setTimeout(() => {
      this.performSearch(event.target.value)
    }, 300)
  }

  performSearch(query) {
    // Use Turbo to update search results
    const form = document.createElement('form')
    form.style.display = 'none'
    form.method = 'GET'
    form.action = window.location.pathname
    
    const searchInput = document.createElement('input')
    searchInput.type = 'hidden'
    searchInput.name = 'search'
    searchInput.value = query
    form.appendChild(searchInput)
    
    form.setAttribute('data-turbo', 'true')
    form.setAttribute('data-turbo-frame', 'search_results')
    
    document.body.appendChild(form)
    form.submit()
    document.body.removeChild(form)
  }

  disconnect() {
    if (this.timeout) {
      clearTimeout(this.timeout)
    }
  }
}